import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { GetList, AddItem } from '../../REST/crud';
import Button from '@mui/material/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';
import WorkflowDialogShell from '../../themes/components/WorkflowDialogShell';

export default function PropertyAreas() {
    const [mode, setMode] = useState(null)
    const navigate = useNavigate()

    const columns = [
        { field: 'name', headerName: 'Name', flex: 0.5 },
        { field: 'description', headerName: 'Description', flex: 0.5 }
    ];

    const fetchPropertyAreas = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetList('PropertyArea', params);

        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }

        if (Array.isArray(result.data)) {
            return {
                data: result.data,
                pagination: { total: result.data.length, page: 1, totalPages: 1 }
            };
        }

        return { data: [], pagination: { total: 0, page: 1, totalPages: 0 } };
    }, []);

    const handleMode = (mode) => { setMode(mode) }

    const handleData = (data) => {
        AddItem('PropertyArea', data).then(() => {
            setMode(null)
        })
    }

    return <Fragment>
        <PageShell>
            <PageHeader
                title="Property Areas"
                back
                onBack={() => navigate(-1)}
                actions={
                    <Action
                        primary
                        icon={<AddIcon />}
                        label="Add Property Area"
                        onClick={() => handleMode({})}
                    />
                }
            />

            {mode !== null && <FormDialog open={mode !== null} handleClose={() => handleMode(null)} handleSave={handleData} />}

            <PageContent fill>
                <ResponsiveDataGrid
                    columns={columns}
                    fetchData={fetchPropertyAreas}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                    getRowId={(i) => i?._id}
                />
            </PageContent>
        </PageShell>
    </Fragment>
}


function FormDialog({ open = false, handleClose, handleSave }) {
    const schema = yup.object({
        name: yup.string().trim().required(),
        description: yup.string()
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: {
            name: '',
            description: ''
        },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        clearErrors()
        reset()
    }, [open, clearErrors, reset])

    const onSubmit = handleSave

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'


    return <WorkflowDialogShell
        open={open}
        onClose={handleClose}
        onSave={handleSubmit(onSubmit)}
        title="Property Area"
    >
        <>
            <Controller name="name" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message} fullWidth label='Name' {...field} />} />
            <Controller name="description" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.description)} helperText={errors.description && errors.description.message} fullWidth label='Description' {...field} />} />
        </>
    </WorkflowDialogShell>
}
